import { Builder } from "@builder.io/react";

import { BuilderSearch } from "./BuilderSearch";

export const registerBuilderSearch = () => {
  Builder.registerComponent(BuilderSearch, {
    name: "Search",
    hideFromInsertMenu: false,
    // to make sure search is not wrapped in a div
    noWrap: true,
    canHaveChildren: false,
    inputs: [
      {
        name: "placeholder",
        type: "string",
        defaultValue: "Search...",
        localized: true,
      },
      {
        name: "variant",
        type: "string",
        enum: ["page", "global"],
        defaultValue: "page",
        helperText:
          "Choose the search variant - 'page' for page-level search, 'global' for global search",
      },
      {
        name: "disabled",
        type: "boolean",
        defaultValue: false,
        helperText: "Whether the search input is disabled",
      },
      {
        name: "value",
        type: "string",
        helperText: "Initial value for the search input",
      },
      {
        name: "showClearButton",
        type: "boolean",
        defaultValue: true,
        helperText: "Whether to show the clear button when there's a value",
      },
      {
        name: "dataTestId",
        type: "string",
        helperText: "Data test ID for testing purposes",
      },
    ],
  });
};
